"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VideoLayout = void 0;
var _mui = require("@ori-ui/mui");
var _editorialFetching = require("@ori/editorial-fetching");
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _common = require("../../common");
var _utils = require("../../utils");
var _styles = require("./styles");
var _videoLayoutClasses = require("./videoLayoutClasses");
var _jsxRuntime = require("react/jsx-runtime");
const VideoLayout = (param)=>{
    let { banner, debug, modulePosition, isStandaloneVideo } = param;
    const { modules, layout } = banner;
    const { getTestId } = (0, _testidGenerator.default)();
    if (!(modules === null || modules === void 0 ? void 0 : modules[0])) {
        return (0, _utils.getModulesContentError)({
            debug,
            layout,
            modulePosition
        });
    }
    const { backgroundVideo } = modules[0];
    if (!backgroundVideo) {
        return (0, _utils.renderOrThrowError)({
            debug,
            message: "".concat(layout, " module must have backgroundVideo set."),
            modulePosition,
            layout
        });
    }
    const { playInLoop, id, type } = backgroundVideo;
    if (!id) {
        return (0, _utils.renderOrThrowError)({
            debug,
            message: "".concat(layout, " module backgroundVideo must have id set."),
            modulePosition,
            layout
        });
    }
    if (type !== _editorialFetching.VideoType.Mp4) {
        const embedUrl = type === _editorialFetching.VideoType.Youtube ? _common.YOUTUBE_MEDIA_URL : _common.YOUKU_MEDIA_URL;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ExternalVideoRoot, {
            className: _videoLayoutClasses.videoLayoutClasses.externalRoot,
            isStandaloneVideo: isStandaloneVideo,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                allowFullScreen: true,
                className: _videoLayoutClasses.videoLayoutClasses.iframe,
                sandbox: "allow-same-origin allow-scripts allow-presentation",
                title: "Video",
                "data-testid": "iframe-video",
                src: "".concat(embedUrl).concat(id),
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            })
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.NoSsr, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.VideoWrapper, {
            className: _videoLayoutClasses.videoLayoutClasses.root,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_presentationComponents.Video, {
                className: _videoLayoutClasses.videoLayoutClasses.video,
                src: id,
                playInLoop: playInLoop !== null && playInLoop !== void 0 ? playInLoop : false,
                "data-testid": getTestId(_editorialFetching.EditorialBannerLayoutEnum.Video)
            })
        })
    });
};
exports.VideoLayout = VideoLayout;
